export default __webpack_public_path__ + "menu-mother-order-smop-icon.0f3baf6798c44e4e3bb6a101cf014bfc.svg";